import React, { useEffect } from 'react';
import { graphql } from 'gatsby';
import Cookies from 'js-cookie';

// Layout component
import Layout from '../components/layout';

// Home page components
import HomeHero from '../components/home/HomeHero';
import Clients from '../components/home/Clients';
import Features from '../components/home/Features';
import Testimonials from '../components/home/Testimonials';
import DigitalChecks from '../components/home/DigitalChecks';
import WhiteLabel from '../components/home/WhiteLabel';

// Utility functions
import localeRedirect from '../utils/locale';

export const IndexPageTemplate = props => {
    useEffect(() => {
        const params = new URLSearchParams(document.location.search);
        params.get('click_id') && Cookies.set('click_id', params.get('click_id'));
        params.get('utm_term') && Cookies.set('utm_term', params.get('utm_term'));
        params.get('utm_campaign') && Cookies.set('utm_campaign', params.get('utm_campaign'));
        params.get('utm_source') && Cookies.set('utm_source', params.get('utm_source'));
        params.get('utm_medium') && Cookies.set('utm_medium', params.get('utm_medium'));
        params.get('hsa_acc') && Cookies.set('hsa_acc', params.get('hsa_acc'));
        params.get('hsa_cam') && Cookies.set('hsa_cam', params.get('hsa_cam'));
        params.get('hsa_grp') && Cookies.set('hsa_grp', params.get('hsa_grp'));
        params.get('hsa_ad') && Cookies.set('hsa_ad', params.get('hsa_ad'));
        params.get('hsa_src') && Cookies.set('hsa_src', params.get('hsa_src'));
        params.get('hsa_tgt') && Cookies.set('hsa_tgt', params.get('hsa_tgt'));
        params.get('hsa_kw') && Cookies.set('hsa_kw', params.get('hsa_kw'));
        params.get('hsa_mt') && Cookies.set('hsa_mt', params.get('hsa_mt'));
        params.get('hsa_net') && Cookies.set('hsa_net', params.get('hsa_net'));
        params.get('hsa_ver') && Cookies.set('hsa_ver', params.get('hsa_ver'));
        params.get('g_clid') && Cookies.set('g_clid', params.get('g_clid'));
    }, []);
    
    const {
        hero,
        clients,
        features,
        testimonials,
        digitalChecks,
        whiteLabel,
        locale = '',
    } = props;
    return (
        <>
            <HomeHero {...hero} />

            <Clients {...clients} />

            <Features locale={locale} {...features} />

            <Testimonials {...testimonials} />

            <DigitalChecks {...digitalChecks} />

            <WhiteLabel locale={locale} {...whiteLabel} />
        </>
    );
};

const IndexPage = ({ data }) => {
    localeRedirect(); // Redirect to the user's locale if set in the browser
    const { contentJson: content } = data;

    return (
        <Layout id="root" metadata={content.metadata}>
            <IndexPageTemplate {...content} />
        </Layout>
    );
};

export default IndexPage;

export const pageQuery = graphql`
    query IndexContent {
        contentJson(path: { eq: "/index" }) {
            metaData {
                title
                description
                siteName
                url
                keywords
            }
            hero {
                title
                titleWords {
                    word
                }
                description
                buttons {
                    link
                    text
                    option
                }
            }
            clients {
                companies {
                    name
                    image
                }
            }
            features {
                title
                description {
                    paragraph
                }
                button {
                    link
                    text
                }
                featureItems {
                    title
                    description
                    image
                    link
                }
            }
            testimonials {
                companies {
                    image
                    company
                    quote
                    name
                    position
                }
            }
            digitalChecks {
                title
                description {
                    paragraph
                }
                points {
                    image
                    header
                    text
                    button {
                        link
                        text
                    }
                }
                image
            }
            whiteLabel {
                title
                description {
                    paragraph
                }
                points {
                    image
                    header
                    text
                    button {
                        link
                        text
                    }
                }
                image
            }
        }
    }
`;
